import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import * as userSelectors from 'services/user/selectors'
import * as routeSelectors from 'services/routes/selectors'
import styles from './_directions.css'
import { FormattedDistance } from 'shared/units'

const mapStateToProps = (state) => ({
  directions: routeSelectors.selectDirections(state),
  units: userSelectors.selectUnitPreference(state),
})

export class Directions extends Component {

  static propTypes = {
    directions: PropTypes.array,
  };

  createHTML (html) {
    return { __html: html }
  }

  renderDirections (directions) {
    return directions.map((d, idx) => (
      <div className={styles.row} key={idx}>
        <div className={styles.distance}>
          <FormattedDistance digits={2} value={d.distance} />
        </div>
        <div className={styles.instruction}>
          <span dangerouslySetInnerHTML={this.createHTML(d.text)} />
        </div>
      </div>
    ))
  }

  render () {
    const { directions } = this.props
    return (
      <section className={styles.container}>
        <div className={styles.table}>
          {directions && directions.length ?
            this.renderDirections(directions)
          :
            <div className={styles.directionsNotAvailable}>
              <FormattedMessage
                id='route.print.directions.notavailable'
                defaultMessage='Directions Not Available'
              />
            </div>
          }
        </div>
      </section>
    )
  }

}

export default connect(mapStateToProps)(Directions)
